import { Component, Inject, OnInit, Optional, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-bulk-update',
  templateUrl: './bulk-update.component.html',
  styleUrls: ['./bulk-update.component.scss'],
  encapsulation :ViewEncapsulation.None
})
export class BulkUpdateComponent implements OnInit {

  selectedPolls;
  allGroups;
  selectedPollIds;
  selectedOption;
  constructor(
    public dialogRef: MatDialogRef<BulkUpdateComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar
  ) { 
    this.selectedPolls = data.selectedPolls;
    this.selectedPollIds = data.selectedPollIds;
   }

  ngOnInit(): void {
    this._apiService.getGroupList().subscribe(res => {
      if (res) {
        this.allGroups = res;
        console.log('allgroups',res);
      }
    },
    (error)=>{
      console.log(error);
    });
  }

  manualUpdate(){
    debugger;
    let data = {poll_ids:this.selectedPollIds,group_id:this.selectedOption.id};
    console.log(data)
    this._apiService.bulkUpdatePollsWithGroup(data).subscribe(res => {
       if (res) {
          debugger;
          console.log( res);
          this.dialogRef.close();
       }
    },
    (error)=>{
       this._snackBar.open('Error Occured : '+error, 'OK', { duration: 3000 });
       this.dialogRef.close();
    });
  }


  onClickClose(){
    this.dialogRef.close();
  }


}
